@if ($isVisible()) {
    <section class="announcer-container" [class]="'announcer-' + $level()">
        <div class="content-wrapper">
            <i class="fas fa-info-circle level-icon"
               [ngClass]="{
                   'fa-circle-radiation': $level() == 0,
                   'fa-circle-exclamation': $level() == 1,
                   'fa-info-circle': $level() == 2
               }"
            ></i>

            <div class="announcement">
                <h4 class="title">{{ $title() }}</h4>
                <p class="description">{{ $message() }}</p>
            </div>

            <i class="fas fa-times close-button" (click)="close()"></i>
        </div>
    </section>
}
